import React from 'react';
export const Card = ({
  className = '',
  children
}) => {
  return <div className={`bg-white border rounded-lg shadow-sm ${className}`} data-id="element-676">
      {children}
    </div>;
};
export const CardContent = ({
  className = '',
  children
}) => {
  return <div className={`p-4 ${className}`} data-id="element-677">{children}</div>;
};